// extracted by mini-css-extract-plugin
export default {"container":"heroSection_container__9ocEy","brand":"heroSection_brand__2iCr7","brandEnglish":"heroSection_brandEnglish__NvxPM","brandJapanese":"heroSection_brandJapanese__Km9YD"};